function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import React from 'react';
import classnames from 'classnames';
var Container = function(param) {
    var children = param.children, className = param.className, isSecondary = param.isSecondary, isTertiary = param.isTertiary, _param_noBorder = param.noBorder, noBorder = _param_noBorder === void 0 ? false : _param_noBorder;
    var _obj;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames('Container', (_obj = {
            secondary: isSecondary,
            tertiary: isTertiary
        }, _define_property(_obj, className, className), _define_property(_obj, "noBorder", noBorder), _obj))
    }, children);
};
export default Container;
